export const THEME_COLORS = [
  "#f87171", // Red-400
  "#ef4444", // Red-500
  "#fb923c", // Orange-400
  "#f97316", // Orange-500
  "#fbbf24", // Amber-400
  "#f59e0b", // Amber-500
  "#22c55e", // Green-500
  "#15803d", // Green-700
  "#38bdf8", // Sky-400
  "#0ea5e9", // Sky-500
  "#818cf8", // Indigo-400
  "#6366f1", // Indigo-500
  "#111827", // black-900
];
